__turbopack_context__.v({
  "border--none": "eTaUXW_border--none",
  "borderColor--warning": "eTaUXW_borderColor--warning",
  "button": "eTaUXW_button",
  "colorScheme--muted": "eTaUXW_colorScheme--muted",
  "colorScheme--none": "eTaUXW_colorScheme--none",
  "container": "eTaUXW_container",
  "current": "eTaUXW_current",
  "field": "eTaUXW_field",
  "icon": "eTaUXW_icon",
  "input": "eTaUXW_input",
  "isEmpty": "eTaUXW_isEmpty",
  "modal": "eTaUXW_modal",
  "placeholder": "eTaUXW_placeholder",
  "requiredInput": "eTaUXW_requiredInput",
  "showCurrent": "eTaUXW_showCurrent",
  "size--lg": "eTaUXW_size--lg",
  "size--sm": "eTaUXW_size--sm",
  "width--maxcontent": "eTaUXW_width--maxcontent",
  "wiggle--a": "eTaUXW_wiggle--a",
  "wiggle--b": "eTaUXW_wiggle--b",
});
